import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'flowbite-react';

/** Home entry to browse / join chits (member path). */
const JoinAsGuestSection = ({ theme }) => {
  const dark = theme === 'dark';

  return (
    <section
      className={`py-14 md:py-20 font-poppins ${
        dark ? 'bg-[#120a08]' : 'bg-white'
      }`}
      aria-labelledby="join-chit-heading"
    >
      <div className="px-[5%] xl:px-[8%] max-w-6xl mx-auto">
        <div
          className={`relative overflow-hidden rounded-2xl px-6 py-10 md:px-12 md:py-14 ${
            dark
              ? 'bg-gradient-to-br from-[#2a1512] via-[#1a0f0d] to-[#C74132]/40'
              : 'bg-gradient-to-br from-[#FDE6E4] via-[#fff] to-[#FBD4CE]'
          }`}
        >
          <div className="relative z-10 max-w-xl">
            <p className="text-sm font-semibold uppercase tracking-widest text-primaryColor mb-3">
              For savers
            </p>
            <h2
              id="join-chit-heading"
              className={`text-2xl md:text-4xl font-bold mb-3 leading-tight ${
                dark ? 'text-white' : 'text-[#1a1212]'
              }`}
            >
              Ready to join a chit?
            </h2>
            <p
              className={`text-base md:text-lg mb-6 ${
                dark ? 'text-[#E3E5ED]' : 'text-[#444]'
              }`}
            >
              Browse open plans, tell a company you&apos;re interested, or join with
              a quick mobile OTP — no paperwork to get started.
            </p>
            <Link to="/join">
              <Button color="failure" className="bg-primaryColor px-6">
                Explore chits
              </Button>
            </Link>
          </div>
          <div
            className="pointer-events-none absolute -right-8 -bottom-8 w-48 h-48 md:w-64 md:h-64 rounded-full opacity-30 bg-primaryColor blur-2xl"
            aria-hidden
          />
        </div>
      </div>
    </section>
  );
};

export default JoinAsGuestSection;
